var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "bottom-end", width: "600", trigger: "click" },
      on: { "after-enter": _vm.open, "after-leave": _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "sales-charts" },
        [
          _c("div", { staticClass: "title" }, [_vm._v("备货明细")]),
          _vm._v(" "),
          _c("op-table", { attrs: { "data-list": _vm.tableData } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "text-decoration": "underline" },
          attrs: { type: "text" },
        },
        [_vm._v("22222")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }